<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
            <span class="pull-left py-3">
              <h2 class="text-purple-manax m-0 pl-3 title-section">Empresas</h2>
              <p class="text-purple-manax pl-3">Estadísticas de Uso</p>
            </span>
            <span class="pull-right py-3 pr-3">
              <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="openCompanies()">
                <i class="material-icons">store</i> Listado
              </button>
            </span>
              <table class="table table-hover m-0 align-top" stickyHeader stickyFooter>

                <thead class="text-purple-manax">
                  <tr>

                    <!-- All -->
                    <th class="p-0 pl-2">
                      <div class="form-check m-0 mx-2">
                        <label class="form-check-label">
                          <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                            [checked]="selection.all">
                          <span class="form-check-sign">
                            <span class="check"></span>
                          </span>
                        </label>
                      </div>
                    </th>

                    <!-- PC -->
                    <th class="d-none d-md-table-cell">
                      Nombre
                    </th>
                    <th class="d-none d-md-table-cell">
                      Email
                    </th>
                    <th class="d-none d-md-table-cell">
                      Teléfono
                    </th>
                    <th class="d-none d-md-table-cell">
                      Inicio
                    </th>
                    <th class="d-none d-md-table-cell">
                      Rubro
                    </th>
                    <th class="d-none d-md-table-cell">
                      Tamaño
                    </th>
                    <th class="d-none d-md-table-cell column-header">
                      Días
                    </th>
                    <th class="d-none d-md-table-cell column-header">
                      <i class="material-icons">business_center</i>
                      <div class="hidden-label">Trabajos</div>
                    </th>
                    <th class="d-none d-md-table-cell column-header">
                      <i class="material-icons">face</i>
                      <div class="hidden-label">Clientes</div>
                    </th>
                    <th class="d-none d-md-table-cell column-header">
                      <i class="material-icons">person</i>
                      <div class="hidden-label">Usuarios</div>
                    </th>
                    <th class="d-none d-md-table-cell column-header">
                      <i class="material-icons">groups</i>
                      <div class="hidden-label">Trabajad.</div>
                    </th>
                    <th class="d-none d-md-table-cell column-header">
                      <i class="material-icons">access_time</i>
                      <div class="hidden-label">Marcac.</div>
                    </th>
                    <th class="d-none d-md-table-cell column-header">
                      <i class="material-icons">forum</i>
                      <div class="hidden-label">Coment.</div>
                    </th>
                    <th class="d-none d-md-table-cell column-header">
                      <i class="material-icons">request_quote</i>
                      <div class="hidden-label">Presup.</div>
                    </th>
                    <th class="d-none d-md-table-cell column-header">
                      <i class="material-icons">paid</i>
                      <div class="hidden-label">Facturas</div>
                    </th>
                    <th class="d-none d-md-table-cell column-header" style="width: 80px;">
                      Trial<br>
                      <select class="filter small" [(ngModel)]="filter.filters.isTrial"
                        (ngModelChange)="getCompaniesWhitStats(true)" (click)="$event.stopPropagation()">
                        <option [ngValue]="false"> No </option> <!-- isDeleted: false -->
                        <option [ngValue]="true"> Si </option> <!-- isDeleted: true -->
                        <option [ngValue]="undefined"> todos </option>
                      </select>
                    </th>

                    <!-- Mobile -->
                    <th class="d-table-cell d-md-none">
                      Orden por: <span class="ml-2">{{sortOptions[filter.sort || ''] || 'ninguno'}}</span>
                      <span class="text-purple-manax pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
                    </th>

                    <!-- All -->
                    <th class="td-actions text-right p-0">
                      <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                        [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                        <i class="material-icons">more_vert</i>
                      </button>
                      <mat-menu #menu="matMenu">

                        <!-- sort order -->
                        <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                          <span>Orden</span>
                        </button>

                        <!-- filters -->
                        <button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                          <span>Filtros</span>
                        </button>
                      </mat-menu>

                      <mat-menu #order="matMenu">
                        <ng-container *ngFor="let key of sortOptionsKeys">
                          <button mat-menu-item (click)="sortCompanies(key)">
                            <span>{{sortOptions[key]}}</span>
                          </button>
                        </ng-container>
                        <button mat-menu-item (click)="sortCompanies('')">
                          <span>Sin Ordenar</span>
                        </button>
                      </mat-menu>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let company of companies" [class.text-danger]="company.isDeleted" class='cursor-pointer'
                    (click)="openCompanyModal(company, true)">

                    <!-- All -->
                    <td class="p-0 pl-2" (click)="$event.stopPropagation();">
                      <div class="form-check m-0 mx-2">
                        <label class="form-check-label">
                          <input class="form-check-input input-sm" type="checkbox"
                            (click)="toggleSelection(company._id)" [checked]="selection.all || selection[company._id || '']">
                          <span class="form-check-sign">
                            <span class="check"></span>
                          </span>
                        </label>
                      </div>
                    </td>

                    <!-- PC -->
                    <td class="d-none d-md-table-cell">
                      {{company.name}}
                    </td>
                    <td class="d-none d-md-table-cell">
                      {{company.email}}
                    </td>
                    <td class="d-none d-md-table-cell">
                      {{company.phone}} <br>
                      <a (click)="openWhatsapp(company.phone, $event)" *ngIf="company.phone" style="color: inherit; text-decoration: none;"> 
                        <i class="fa fa-whatsapp"></i>
                      </a>
                    </td>
                    <td class="d-none d-md-table-cell">
                      {{company.createdAt | date:'dd/MM/yyyy'}}
                    </td>
                    <td class="d-none d-md-table-cell">
                      {{company.trial?.companyCategory}}
                    </td>
                    <td class="d-none d-md-table-cell">
                      {{company.trial?.companySize}}
                    </td>
                    <td class="d-none d-md-table-cell column-cell text-right" style="width: 60px;">
                      {{company.createdAtDays || 0}}
                    </td>
                    <td class="d-none d-md-table-cell column-cell text-right" style="width: 60px;">
                      {{company.tasks || 0}}
                    </td>
                    <td class="d-none d-md-table-cell column-cell text-right" style="width: 60px;">
                      {{company.clients || 0}}
                    </td>
                    <td class="d-none d-md-table-cell column-cell text-right" style="width: 60px;">
                      {{company.users || 0}}
                    </td>
                    <td class="d-none d-md-table-cell column-cell text-right" style="width: 60px;">
                      {{company.workers || 0}}
                    </td>
                    <td class="d-none d-md-table-cell column-cell text-right" style="width: 60px;">
                      {{company.timetracks || 0}}
                    </td>
                    <td class="d-none d-md-table-cell column-cell text-right" style="width: 60px;">
                      {{company.movements || 0}}
                    </td>
                    <td class="d-none d-md-table-cell column-cell text-right" style="width: 60px;">
                      {{company.quotes || 0}}
                    </td>
                    <td class="d-none d-md-table-cell column-cell text-right" style="width: 60px;">
                      {{company.billingdocuments || 0}}
                    </td>
                    <td class="d-none d-md-table-cell text-right" style="width: 80px;">
                      {{company.isTrial ? 'Si' : 'No'}}
                    </td>

                    <!-- Mobile -->
                    <td class="d-table-cell d-md-none" style="line-height: 14px;">
                      <b>{{company.name}} <span *ngIf="company.isTrial">(TRIAL)</span></b><br>
                      Inicio: {{company.createdAt | date:'dd/MM/yyyy'}}, {{company.createdAtDays || 0}} días - 
                      Empresa: {{company.trial?.companyCategory}}, {{company.trial?.companySize}} -
                      Trabajos: {{company.tasks || 0}} - Clientes: {{company.clients || 0}} - 
                      Usuarios: {{company.users || 0}} - Trabajadores: {{company.workers || 0}} - 
                      Fichajes: {{company.timetracks || 0}} -  Fotos y Notas: {{company.movements || 0}} - 
                      Presupuestos: {{company.quotes || 0}} - Facturas: {{company.billingdocuments || 0}}
                    </td>

                    <!-- All -->
                    <td class="td-actions text-right p-0">
                      <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                        [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                        <i class="material-icons">more_vert</i>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="openCompanyModal(company, true)">
                          <span>Abrir</span>
                        </button>
                        <button mat-menu-item (click)=" openDeleteCompanyConfirm(company)">
                          <span>Eliminar</span>
                        </button>
                      </mat-menu>
                    </td>
                  </tr>

                  <!-- All -->
                  <tr *ngIf="thereAreMore && !loading">
                    <td colspan="10">
                      <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                        mas</button>
                    </td>
                  </tr>
                  <tr *ngIf="loading">
                    <td colspan="10">Cargando...</td>
                  </tr>
                </tbody>
                <tfoot class="text-purple-manax">
                  <tr>
                    <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ companies.length }} empresas</td>
                  </tr>
                </tfoot>
              </table>
      </div>
    </div>
  </div>
</div>